module.exports = __webpack_public_path__ + "img/8.7b9233b8.png";